export default {
	alert: {
		abortedFilter: {
			description: 'Download was cancelled due to a filter change, please try again.',
			title: 'Download aborted',
		},
		abortedPage: {
			description: 'Download was cancelled due to a page change, please try again.',
			title: 'Download aborted',
		},
		failed: {
			description: `We couldn't generate your file - please try again.`,
			title: 'Download failed',
		},
		pending: {
			description: 'Please wait as we generate your file.',
			title: 'Downloading vehicles',
		},
	},
	button: {
		ariaLabel: 'Download CSV button',
		label: 'Download',
	},
	popover: {
		button: {
			ariaLabel: 'Download selected CSV button',
			label: 'Download',
		},
	},
	tooltipLabel: 'Download CSV',
};
